var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1908 2.87927C9.7525 1.77093 5.25667 4.0326 2.50084 7.91844C2.42084 8.03094 8.0875 5.92677 10.1042 6.82844C8.8925 8.6226 7.1925 10.7918 5.00084 13.3351L6.6675 13.7518L5.83417 16.6684C9.79084 13.0351 12.2467 10.6576 13.2017 9.5351C14.9425 13.4168 12.3867 18.4101 12.5008 18.3351C13.7883 17.4884 17.5008 13.3351 17.5008 9.16843C17.5008 7.50177 17.0825 6.01177 16.3433 5.21677C16.3392 5.2126 15.9717 4.85677 16.2017 4.06843C16.325 3.64843 16.7575 2.84927 17.5008 1.66843L16.245 1.66843C15.0975 1.66844 14.02 2.0976 13.1908 2.87927Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 20) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyIcon);
export default __webpack_public_path__ + "static/media/fly-icon.e7ab213c907598b4d13b6bc71b00f197.svg";
export { ForwardRef as ReactComponent };